import { render } from "./OrganizerSetting.vue?vue&type=template&id=e515a336"
import script from "./OrganizerSetting.vue?vue&type=script&lang=js"
export * from "./OrganizerSetting.vue?vue&type=script&lang=js"

import "./OrganizerSetting.vue?vue&type=style&index=0&id=e515a336&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__